import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box } from '@mui/material'
import useSelectedUserRoutes from 'src/Hooks/useSelectedUserRoutes'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { BlankViewImageVariants, BlankView } from 'src/Components/blank-view'

/**
 * Error page displayed for invalid paths
 */
const InvalidPage: React.FC = () => {
  const { t } = useCustomTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const title = location.state?.titleKey || 'errors.pageNotFound.messageTitle'
  const explanation = location.state?.explanationKey || 'errors.pageNotFound.message'
  const hideAction = location.state?.hasAction === false
  const action = {
    text: 'common.back',
    onClick: () => navigate(-1),
  }
  useSelectedUserRoutes(t('errors.pageNotFound.title'))

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '80%' }} data-qa="invalid-page">
      <BlankView imageVariant={BlankViewImageVariants.Worried} title={title} explanation={explanation} action={hideAction ? undefined : action} />
    </Box>
  )
}

export default InvalidPage
